__turbopack_context__.v({
  "bar": "CategoryChip-module-scss-module__J6QYvG__bar",
  "chip": "CategoryChip-module-scss-module__J6QYvG__chip",
});
